import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import api from '../../config/api';
import useDynamicTranslation from '../../Hook/useDynamicTranslation';
import { getImageUrl } from '../../utils/imageUrl';
import './AdminBanners.css';

/** Promotional banners managed in the admin panel (global + the customer's city). */
const AdminBanners = ({ city }) => {
  const navigate = useNavigate();
  const [banners, setBanners] = useState([]);
  const { getText } = useDynamicTranslation(banners.map((b) => b.title));

  useEffect(() => {
    let active = true;
    api
      .get('/web-user/home/banners', { params: { city: city || undefined } })
      .then((res) => active && setBanners(Array.isArray(res.data?.banners) ? res.data.banners : []))
      .catch(() => active && setBanners([]));
    return () => { active = false; };
  }, [city]);

  if (banners.length === 0) return null;

  const openBanner = (banner) => {
    const restaurantId = banner.restaurant?._id || (banner.targetModel === 'Restaurant' ? banner.targetId : null);
    if (restaurantId) navigate(`/restaurant/${restaurantId}`);
  };

  return (
    <section className="admin-banners" aria-label="Promotions">
      <div className="admin-banners__track">
        {banners.map((banner) => {
          const clickable = Boolean(banner.restaurant?._id || banner.targetId);
          return (
            <button
              type="button"
              key={banner._id}
              className={`admin-banners__card ${clickable ? '' : 'is-static'}`}
              onClick={() => openBanner(banner)}
              disabled={!clickable}
            >
              <img src={getImageUrl(banner.image)} alt={getText(banner.title)} loading="lazy" onError={(e) => { e.currentTarget.style.visibility = 'hidden'; }} />
              {banner.title && <span className="admin-banners__title">{getText(banner.title)}</span>}
            </button>
          );
        })}
      </div>
    </section>
  );
};

export default AdminBanners;
